import React from "react";

import { useProfile } from "@/customHooks/useProfile";
import { useTranslation } from "next-i18next";
import { Folder } from "~types/folder";

import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography
} from "@mui/material";

interface FolderDeleteDialogProps {
  isOpen: boolean;
  toggleDrawer: any;
  closeFolderDrawer: any;
  closeMoreDrawer: any;
  folder: Folder;
}

export const FolderDeleteDialog = ({
  isOpen,
  toggleDrawer,
  closeFolderDrawer,
  closeMoreDrawer,
  folder
}: FolderDeleteDialogProps): JSX.Element => {
  const { removeFolder } = useProfile();
  const { t } = useTranslation("searchpage");
  const handleClickCancel = () => {
    toggleDrawer(false);
  };
  const handleClickOk = async () => {
    console.log("folder", folder);
    try {
      await removeFolder.mutateAsync({ folderName: folder.name });
      closeMoreDrawer();
      closeFolderDrawer();
    } catch (e) {
      console.log("Can't remove folder");
    }
  };

  return (
    <Dialog
      PaperProps={{
        sx: { borderRadius: 2, pb: 2 }
      }}
      onClose={() => toggleDrawer(false)}
      open={isOpen}>
      <DialogTitle fontSize={18} fontWeight={400}>
        {t("favourites.delete-dialog.title")}
      </DialogTitle>
      <DialogContent>
        <Typography>{t("favourites.delete-dialog.body")}</Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: "end" }}>
        <Button variant={"text"} color={"orange"} onClick={handleClickCancel}>
          {t("favourites.delete-dialog.cancel")}
        </Button>
        <Button variant={"text"} color={"green"} onClick={handleClickOk}>
          <>
            {!removeFolder.isLoading && t("favourites.delete-dialog.ok")}
            {removeFolder.isLoading && (
              <CircularProgress color={"green"} size={14} />
            )}
          </>
        </Button>
      </DialogActions>
    </Dialog>
  );
};
